<template>
    <MainPage :theme="theme">
        <template #header>
            <Topbar :theme="theme" :appName="state.appName" @onClickBack="onClickBack()"></Topbar>
        </template>
        <template #content> 
            <div class="px-4 -mt-8">
                <div class="min-h-screen h-full rounded-t-3xl w-full bg-white text-semi" >
                    <div class="pt-8 text-center px-4">
                        <div class="text-18" :style="state.textTitle">{{ title }}</div>
                        <div class="mt-2 text-16 text-black">{{ subTitle }}</div>
                        <div class="w-full min-w-[320px] max-w-lg mx-auto mt-5" v-if="banner">
                            <img class="rounded-xl" :src="banner" alt="">
                        </div>
                        <div class="border-b border-a-gray-dfdfdf w-full mt-4"></div>
                    </div>
                    <div class="p-5">
                        <div v-for="(detail,index) of detailInfo" :key="index">
                            <div class="text-16">{{ detail.title }}</div>
                            <div class="text-14 my-3" :style="state.textPrize">{{ detail.detail }}</div>
                            <div class="w-full min-w-[320px] max-w-lg mx-auto" v-if="detail.image_url">
                                <img class="rounded-xl m-auto" :src="detail.image_url" alt="">
                            </div>
                            <div class="flex justify-between my-6 text-black text-14" v-for="(item,k) of detail.winners" :key="k">
                                <div :class="[item.description.length < 20 ? '':'xs-min-max:w-36 w-48 usm:w-10/12']">
                                    <div>{{ k+1 }}.
                                        <span class="ml-1">คุณ</span>
                                        <span class="ml-1 break-all">{{ splitNameFormat(item.description) }}</span>
                                    </div>
                                </div>
                                <div>{{ splitTelFormat(item.description) }}</div>
                            </div>
                            <div :class="[index == detailInfo.length-1 ? '' : 'border-b border-a-gray-dfdfdf w-full my-4']"></div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </MainPage>
</template>
<script>
import { reactive } from "vue";
import { useRoute } from "vue-router";
import AnnouncementService from "../service/AnnouncementService.js"
import MainPage from "../component/Layout/MainPage.vue"
import Topbar from "../component/Topbar/Topbar.vue"
import BzbsApiLegacy from "@/core/Http/BzbsApiLegacy"
import Utility from "@/helper/Utility";
export default {
    name: 'Announcement',
    components: {
        MainPage,
        Topbar
    },
    setup: function () {
        const route = useRoute()
        const state = reactive({
            appName: route.query.app_name,
            appId: route.query.appId,
            round: route.query.round,
            returnUrl: route.query.return_url,
            backgroundStyle: {
                backgroundColor : '',
            },
            textTitle: {
                color: ''
            },
            textPrize: {
                color: ''
            }
        })

        return {
            route: route,
            state: state
        }
    },
    data: function () {
        return {
            theme: null,
            announceInfo: null,
            detailInfo: '',
            title: '',
            subTitle: '',
            banner: '',
            blobWebLanding: ''
        }
    },
    created: async function() { 
        await this.getThemeBlob();
        const blobPath = await this.getBlobApiConfig(this.state)
        await this.getWebLanding(blobPath);
    },
    methods: {
        getBlobApiConfig: function (info) {
            return new Promise((resolve, reject) => {
                let app_id = "";
                const version = 1;
                BzbsApiLegacy.getBlobAppThemeMapping().then((app_mapping) => {   
                    app_id = Utility.getAppIdFromTheme(app_mapping, info.appName);
                    const blob_path = Utility.getUrlBlobJsonFromTheme(app_id, version);
                    resolve(blob_path) 
                }).catch((err) => {
                    console.log(err)
                    this.blobWebLanding = null
                    reject(err)
                });
            })
        },
        getWebLanding: function (blob_path) {
            return new Promise((resolve, reject) => {
                BzbsApiLegacy.getBlobWeblandingConfigByBlobPath(blob_path).then((res_config) => {
                    this.blobWebLanding = res_config
                    this.getDashboardAnnouncement(this.blobWebLanding)
                    resolve(this.blobWebLanding) 
                }).catch((err) => {
                    console.log(err)
                    this.blobWebLanding = null
                    reject(err)
                });
            });
        },
        getThemeBlob: function() {
            return new Promise((resolve) => {
                AnnouncementService.apiGetThemeContent(this.state.appId).subscribe({
                    next: async(data) => {
                        this.theme = await data;
                        this.state.textTitle.color = data.color_1
                        this.state.textPrize.color = data.color_2
                        resolve(data);
                    },
                    error: (err) => {
                        console.log(err);
                    },
                })
            });
        },
        getDashboardAnnouncement: function (blobWebLanding) {
            return new Promise((resolve) => {
                AnnouncementService.apiGetDashboardAnnouncement(this.state, blobWebLanding).subscribe({
                    next: async (res) => {
                        this.announceInfo = await res.data;
                        this.title = this.announceInfo.title_header;
                        this.subTitle = this.announceInfo.subtitle_header;
                        this.banner = this.announceInfo.banner;
                        this.detailInfo = this.announceInfo.winner_list_detail;
                        
                        resolve(res);
                    },
                    error: (err) => {
                        console.log(err);
                    },
                })
            });
        },
        onClickBack: function() {
            window.location.replace(this.state.returnUrl)
        }
    }
}
</script>
<style lang="scss" scoped>
@import "../style/main.scss";
@import '../style/base.scss';
</style>